/**
 * Verbesserungen für Barrierefreiheit bei Elementor Popup
 *
 * Übersetzt Aria-label für den allgemeinen und den Such-Popup-Schließen-Button.
 */
function initPopupCloseButtonAriaLabel() {

    // --- Übersetzungen ---
    const i18nGlobal = (typeof WCO_UI_Translations !== 'undefined') ? WCO_UI_Translations : {};
    const i18nElem = i18nGlobal.elementorPopup || {};

    const labelClose       = i18nElem.close       || 'Close popup';
    const labelCloseSearch = i18nElem.closeSearch || 'Close search box';

    const elementorOriginalClose = 'Close';
    const elementorOriginalSearch = 'Close this search box.';

    /**
     * Sucht in einem gegebenen DOM-Knoten nach Elementor Popup-Schließen-Buttons
     * und übersetzt deren aria-label basierend auf dem Originaltext.
     * @param {Node} node - Der DOM-Knoten, der durchsucht werden soll.
     */
    const translateCloseButton = (node) => {
        if (node.nodeType !== 1) {
            return;
        }

        const selector = `.dialog-close-button[aria-label="${elementorOriginalClose}"], .dialog-close-button[aria-label="${elementorOriginalSearch}"]`;
        const buttons = node.querySelectorAll(selector);

        buttons.forEach(button => {
            const currentLabel = button.getAttribute('aria-label');

            if (currentLabel === elementorOriginalClose) {
                button.setAttribute('aria-label', labelClose);
            } else if (currentLabel === elementorOriginalSearch) {
                button.setAttribute('aria-label', labelCloseSearch);
            }
        });

        // Prüfung, ob der Node selbst der Button ist (wichtig bei MutationObserver)
        if (node.matches && node.matches('.dialog-close-button')) {
            const currentLabel = node.getAttribute('aria-label');
            if (currentLabel === elementorOriginalClose) {
                node.setAttribute('aria-label', labelClose);
            } else if (currentLabel === elementorOriginalSearch) {
                node.setAttribute('aria-label', labelCloseSearch);
            }
        }
    };

    translateCloseButton(document.body);

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    translateCloseButton(node);
                });
            }
        }
    });

    const config = {
        childList: true,
        subtree: true
    };

    observer.observe(document.body, config);
}

export { initPopupCloseButtonAriaLabel };